export default "__VITE_ASSET__DNIsiD_W__"